import React from "react";
import Cards from "../components/Screen2/InrolledCards/Cards";
import Referral2 from "../components/Screen2/Referral/Referral2";

const Screen2 = () => {
  return (
    <div>
      <Referral2 />
      <Cards />
    </div>
  );
};

export default Screen2;